<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Produk Eksklusif</h2>

    <v-card outlined class="px-3 py-3">
      <v-tabs @change="coba">
        <v-tab class="text-caption font-weight-bold">Semua</v-tab>
        <v-tab class="text-caption font-weight-bold">Live</v-tab>
        <v-tab class="text-caption font-weight-bold">Habis</v-tab>
        <v-tab class="text-caption font-weight-bold" v-if="false">Diarsipkan</v-tab>

        <v-tab-item>
          <produkData type="all" v-if="tab == 0"></produkData>
        </v-tab-item>

        <v-tab-item>
          <produkData type="live" v-if="tab == 1"></produkData>
        </v-tab-item>
        
        <v-tab-item>
          <produkData type="sold-out" v-if="tab == 2"></produkData>
        </v-tab-item>

        <v-tab-item v-if="false">
          <produkData type="archieved" v-if="tab == 3"></produkData>
        </v-tab-item>

      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import produkData from './components/produkInternal'

export default {
  components: {
		produkData
	},
  data() {
    return {
      tab : 1,
    }
  },
  methods: {
    ...mapActions('category', ['getCategory']),

    coba(val) {
      this.tab = val
    }
  },
  created() {
    this.$store.dispatch('setPageTitle', `Produk Eksklusif`);
    this.getCategory()
  }
}
</script>